import { resolveTicketEvidenceUrl } from '../../utils/assetUrls';

const DRIVE_LINK_REGEX = /(https?:\/\/(?:drive\.google\.com|docs\.google\.com)[^\s<>"']+)/gi;

export const extractDriveLinks = (text = '') => {
  const matches = text.match(DRIVE_LINK_REGEX);
  return matches ? [...new Set(matches)] : [];
};

const EVIDENCE_PATH_REGEX = /\/uploads\/tickets\/evidence\/[A-Za-z0-9._-]+/g;

/** Parses legacy single path, pipe-separated paths, or JSON array in tickets.evidence_url */
export const parseTicketEvidenceUrls = (evidenceUrl) => {
  if (!evidenceUrl) return [];
  const raw = String(evidenceUrl).trim();
  if (!raw) return [];

  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return [...new Set(parsed.filter(Boolean).map(String))];
      }
    } catch {
      const extracted = raw.match(EVIDENCE_PATH_REGEX);
      if (extracted?.length) {
        return [...new Set(extracted)];
      }
      return [];
    }
  }

  if (raw.includes('|')) {
    return [...new Set(raw.split('|').map((s) => s.trim()).filter(Boolean))];
  }

  return [raw];
};

export const getEvidenceImageUrl = (evidencePath) => {
  if (!evidencePath) return null;
  const path = String(evidencePath).trim();
  if (!path || path.startsWith('[')) return null;
  return resolveTicketEvidenceUrl(path);
};

export const getTotalEvidenceBytes = (files = []) =>
  files.reduce((sum, file) => sum + (file?.size || 0), 0);

export const TICKET_CATEGORIES = ['Bug', 'Error', 'Enhancement', 'Feature Request', 'Other'];

export const TICKET_STATUSES = ['To Do', 'In Progress', 'Testing', 'Deployed', 'Rejected', 'Closed'];

export const MAX_EVIDENCE_BYTES = 20 * 1024 * 1024;
export const MAX_EVIDENCE_FILE_COUNT = 20;

export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];

export const formatEvidenceSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const TICKET_NOTIFICATIONS_REFRESH_EVENT = 'evitals:ticket-notifications-refresh';

export function dispatchTicketNotificationsRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TICKET_NOTIFICATIONS_REFRESH_EVENT));
}

export const formatTicketDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
};

/** Treats DB tinyint/boolean/string values as unread vs read for notification UI */
export const isNotificationUnread = (notification) => {
  const v = notification?.is_read;
  if (v === true || v === 1 || v === '1') return false;
  if (v === false || v === 0 || v === '0') return true;
  return Boolean(v) === false;
};
